import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["fileInput"]
    static values = {
        delay: { type: Number, default: 500 }
    }

    connect() {
        this.submitTimeout = null
        this.isSubmitting = false
    }

    change(event) {
        // For file inputs, check if files were selected
        if (event.target.files) {
            const files = event.target.files
            if (!files || files.length === 0) {
                return
            }
        }

        // Cancel any pending submission
        if (this.submitTimeout) {
            clearTimeout(this.submitTimeout)
            this.submitTimeout = null
        }
        
        // Submit immediately for checkboxes and file inputs
        if (event.target.type === 'checkbox' || event.target.type === 'file') {
            this.submitForm()
        } else {
            // For other inputs, use a delay
            this.submitTimeout = setTimeout(() => {
                this.submitForm()
            }, this.delayValue)
        }
    }

    input(event) {
        // Handle input events (for text fields, range sliders, etc.)
        if (this.submitTimeout) {
            clearTimeout(this.submitTimeout)
        }
        
        this.submitTimeout = setTimeout(() => {
            this.submitForm()
        }, this.delayValue)
    }

    blur(event) {
        // If the input has files and we haven't already submitted via change, then schedule a submit
        if (event.target.files && event.target.files.length > 0 && !this.isSubmitting) {
            this.submitTimeout = setTimeout(() => {
                this.submitForm()
            }, 500)
        }
    }

    submitForm() {
        // Prevent double submission
        if (this.isSubmitting) {
            return
        }
        
        // Clear timeout just in case
        if (this.submitTimeout) {
            clearTimeout(this.submitTimeout)
            this.submitTimeout = null
        }
        
        const form = this.element.closest("form")
        if (!form) return
        
        this.isSubmitting = true
        
        // Show loading state
        this.showLoadingState()
        
        // Submit the form
        form.requestSubmit()
        
        // Reset submitting flag after a delay to allow new submissions
        setTimeout(() => {
            this.isSubmitting = false
        }, 1000)
    }
    
    showLoadingState() {
        // Dispatch custom event that other controllers can listen to
        const event = new CustomEvent('auto-submit:start', {
            bubbles: true,
            detail: { message: 'Saving...' }
        })
        this.element.dispatchEvent(event)
    }
    
    disconnect() {
        if (this.submitTimeout) {
            clearTimeout(this.submitTimeout)
        }
    }
}